// extracted by mini-css-extract-plugin
module.exports = {"BackBtn":"BackBtn_BackBtn__KQPMr","Reversed":"BackBtn_Reversed__1Q-dC","Transparent":"BackBtn_Transparent__1E67G"};